/* related-products.js — <product-recommendations>
   Hydrates the section via /recommendations/products?section_id=...&product_id=...&intent=...&limit=...
   Renders the resulting HTML if it contains products. Otherwise removes itself entirely
   (no orphan heading on empty stores).
*/
(function () {
  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      const sectionId = this.dataset.sectionId;
      const productId = this.dataset.productId;
      const intent = this.dataset.intent || 'related';
      const limit = this.dataset.limit || '4';
      if (!sectionId || !productId) { this.remove(); return; }

      const url = `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'}recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&intent=${encodeURIComponent(intent)}&limit=${encodeURIComponent(limit)}`;

      fetch(url, { headers: { Accept: 'text/html' } })
        .then(r => r.ok ? r.text() : '')
        .then(html => {
          if (!html) { this.remove(); return; }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          // Server returns the section. Look inside <product-recommendations>
          // OR for any product cards. If empty, remove ourselves.
          const fresh = doc.querySelector('product-recommendations, .related-products');
          const hasProducts = doc.querySelector('.related-products__item, .card-product');
          if (!fresh || !hasProducts) { this.remove(); return; }

          // Swap our skeletal shell for the rendered section
          if (fresh.tagName.toLowerCase() === 'product-recommendations') {
            this.innerHTML = fresh.innerHTML;
            this.removeAttribute('hidden');
          } else {
            // It's already the rendered <section> form (recommendations.performed=true on second call)
            this.outerHTML = fresh.outerHTML;
          }
        })
        .catch(() => { this.remove(); });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
